<template>
 <div>
   <br>
   <v-card
    class="mx-auto"
  >

    <v-toolbar
      color="indigo"
      dark
    >
      <v-app-bar-nav-icon></v-app-bar-nav-icon>
         <v-btn
                  @click="backTodisciplinList"
                  class="mx-2"
                  fab
                  dark
                  color="primary"
                  v-on="on"
                >
          <v-icon dark>arrow_back</v-icon>
        </v-btn>
      <v-toolbar-title>Aluno :  {{this.$store.state.objAluno.nome}} - {{this.$store.state.objAluno.idMAtricula}}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-toolbar>

    <v-container fluid>
      <v-row dense>
        <v-col xs="12" sm="12" md="12"

        >

          <strong>Geração de Boletim</strong>
           <v-progress-circular
                          v-if="progresso"
                          indeterminate
                          color="green"
                  ></v-progress-circular>
          <v-card>

               <template>
                   <v-simple-table class="tabela" fixed-header>
    <template v-slot:default>
      <thead>
        <tr>

        </tr>
      </thead>

      <tbody>
          <tr>
             <td rowspan="2" class="tabelath">Nº</td>
             <td rowspan="2" class="tabelath">Disciplina</td>
             <td colspan="4" class="tabelath">1º Trimestre</td>
            <td colspan="4" class="tabelath">2º Trimestre</td>
            <td colspan="3" class="tabelath">3º Trimestre</td>
            <td colspan="6" class="tabelath">Médias</td>
          </tr>
          <tr>
            <td  class="tabela">MAC</td>
            <td  class="tabela">P1</td>
            <td class="tabela">P2</td>
            <td class="tabela">MT</td>
            <td class="tabela">MAC</td>
            <td class="tabela">P1</td>
            <td class="tabela">P2</td>
            <td class="tabela">MT</td>
            <td class="tabela">MAC</td>
            <td class="tabela">P1</td>
            <td class="tabela">MT</td>
            <td class="tabela">CA(A)</td>
            <td class="tabela">CF</td>
            <td class="tabela">PG</td>
            <td class="tabela">CA</td>
            <td class="tabela">EX</td>
            <td class="tabela">MF</td>
        </tr>
        <tr v-for="(item,i) in listaAlunos" :key="i">
          <td  class="tabela">{{ i+1 }}</td>
          <td  class="tabela">{{ item.disciplina }}</td>
          <td  class="tabela">{{ item.t1_mac }}</td>
          <td  class="tabela">{{ item.t1_nota1 }}</td>
          <td  class="tabela">{{ item.t1_nota2 }}</td>
          <td v-if="(item.t1_md <10)" style="color:red" class="tabela">{{ item.t1_md }}</td>
          <td v-if="(item.t1_md >=10)" style="color:blue" class="tabela">{{ item.t1_md }}</td>
          <td  class="tabela">{{ item.t2_mac }}</td>
          <td  class="tabela">{{ item.t2_nota1 }}</td>
          <td  class="tabela">{{ item.t2_nota2 }}</td>
          <td v-if="(item.t2_md <10)" style="color:red" class="tabela">{{ item.t2_md }}</td>
          <td v-if="(item.t2_md>=10)" style="color:blue" class="tabela">{{ item.t2_md }}</td>
          <td  class="tabela">{{ item.t3_mac }}</td>
          <td  class="tabela">{{ item.t3_nota1 }}</td>
          <td v-if="(item.t3_md <10)" style="color:red" class="tabela">{{ item.t3_md }}</td>
          <td v-if="(item.t3_md>=10)" style="color:blue" class="tabela">{{ item.t3_md }}</td>
          <td  class="tabela">{{ item.ca_a }}</td>
          <td  class="tabela">{{ item.MF }}</td>
          <td  class="tabela">{{ item.pg }}</td>
          <td  class="tabela">{{ item.CA }}</td>
          <td v-if="(item.exame  <10)" style="color:red" class="tabela">{{ item.exame }}</td>
          <td v-if="(item.exame >=10)" style="color:blue" class="tabela">{{ item.exame }}</td>
          <td v-if="(item.mfd  <10)" style="color:red" class="tabela">{{ item.mfd }}</td>
          <td v-if="(item.mfd >=10)" style="color:blue" class="tabela">{{ item.mfd }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
                </template>

          </v-card>
        </v-col>
         <v-col md="0">
        </v-col>
      </v-row>
    </v-container>
  </v-card>
 </div>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')

export default {
  data: () => ({
    progresso: false,
    cards: [
      { title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 12 },
      { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6 },
      { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }
    ],
    listaAlunos: [],

    headers: [
      {
        text: 'Disciplina',
        align: 'start',
        sortable: false,
        value: 'disciplina'
      },
      { text: 'Nota', value: 'fat' },
      { text: 'Cadeirante', value: 'carbs' },
      { text: 'Resultante', value: 'protein' }
    ]
  }),

  created () {
    this.CarregaBoletim()
  },

  methods: {
    async CarregaBoletim () {
      this.progresso = true

      const valor =
          {
            matricula: this.$store.state.objAluno.idMAtricula,
            ano: this.$store.state.objAluno.anoLectivo
          }

      try {
        this.listaAlunos = await axios
          .post('/gerarBoletim', valor)
          .then(res => res.data)
        console.log(this.listaAlunos)
        this.progresso = false
      } catch (error) {
        this.progresso = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    backTodisciplinList () {
      this.$router.push('ListaAlunos')
    }
  }
}

/* const ls = require("local-storage");
import axios from "../plugins/axios";
  export default {

    data: () => ({
      cards: [
        { title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 12 },
        { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6 },
        { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 },
      ],
      listaAlunos:[],

      headers: [
          {
            text: 'Disciplina',
            align: 'start',
            sortable: false,
            value: 'name',
          },
          { text: 'Nota', value: 'fat' },
          { text: 'Cadeirante', value: 'carbs' },
          { text: 'Resultante', value: 'protein' },
        ],

    created() {

        console.log("funciona");

        this.Initialize()

      },

      methods:{

      async Initialize()
      {

          const valor =
          {
              matricula:this.$store.state.objAluno.turma,
              ano:this.$store.state.objAluno.anolectivo
          }

              try {
                this.listaAlunos = await axios
                  .get('/gerarBoletim')
                  .then(res => res.data)
                  console.log("funciona");

              } catch (error) {
                this.isLoading = false

                this.text = error
                this.$store.dispatch("textMessage", {"msg":this.text ,"classMessage":"msgError", "timeout":3000 });

              }

      }

      }

    }),
  } */
</script>
<style>
 .tabela {
    border: 1px solid rgba(0,0,0,.12);
    font-size: 12px!important;

}
 .tabelath {
    border: 1px solid rgba(0,0,0,.12);
    font-size: 12px !important;
}
.tdsize {
    width: 3px!important;
}

</style>
